import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import {
  MyDailyBoosterContainer,
  MyDailyBoosterTabContainerWrapper,
  MyDailyBoosterTabContent,
  MyDailyBoosterButtonsContainer,
  MyDailyBoosterTitle,
} from './MyDailyBooster.styled';
import {
  AppContentContainer,
} from '../../../common/sharedStyledComponents/GenericStyles.styled';
import { Card } from '../../../common/sharedComponents/Card';
import { CardContent, CardTitle, SkeletonTabWrapper, SkeletonContentWrapper } from '../Boosters.styled';

export function MyDailyBoosterSkeleton () {
  const tabCount = 3;

  return (
    <MyDailyBoosterContainer>
      <AppContentContainer>
        <MyDailyBoosterTitle>
          <Skeleton width={300} height={28} />
        </MyDailyBoosterTitle>
        <MyDailyBoosterTabContainerWrapper>
          {Array.from({ length: tabCount }).map((_, index) => (
            <SkeletonTabWrapper key={index}>
              <Skeleton width={80} height={40} borderRadius={4} />
            </SkeletonTabWrapper>
          ))}
        </MyDailyBoosterTabContainerWrapper>
        <MyDailyBoosterTabContent>
          <Card>
            <CardTitle>
              <Skeleton width={120} height={24} />
            </CardTitle>
            <CardContent>
              <SkeletonContentWrapper>
                <Skeleton height={20} count={8} />
              </SkeletonContentWrapper>
            </CardContent>
          </Card>
        </MyDailyBoosterTabContent>
        <MyDailyBoosterButtonsContainer>
          <Skeleton width={120} height={48} borderRadius={4} />
          <Skeleton width={120} height={48} borderRadius={4} />
        </MyDailyBoosterButtonsContainer>
      </AppContentContainer>
    </MyDailyBoosterContainer>
  );
}
